import './Error.scss';

const Error = ({message}: any) => (
    <p className='error'>{message}</p>
);

export default Error;
